import { NgModule } from '@angular/core';
import { RollbarLibModule } from './rollbar-lib';
import { UserBaseModule } from './user-base';
import { SettingsBaseModule } from './settings-base';
import { ProjectBaseModule } from './project-base';
import { ServiceStackBaseModule } from './service-stack-base';
import { BillingBaseModule } from './billing-base';
import { NotificationBaseModule } from './notification-base';
import { UserDataBaseModule } from './user-data-base';
import { HttpRoutingBaseModule } from './http-routing-base';
import { PortRoutingBaseModule } from './port-routing-base';
import { AppVersionBaseModule } from './app-version-base';
import { ClientUserBaseModule } from './client-user-base';
import { ResourceStatisticsBaseModule } from './resource-statistics-base';
import { ServiceBaseModule } from './service-base';
import { SubscriptionBaseModule } from './subscription-base';
import { TransactionDebitBaseModule } from './transaction-debit-base';
import { TransactionCreditBaseModule } from './transaction-credit-base';
import { ClientBaseModule } from './client-base';
import { ProcessBaseModule } from './process-base';
import { ClientStatusBaseModule } from './client-status-base';
import { ClientBalanceBaseModule } from './client-balance-base';
import { ProjectStatusBaseModule } from './project-status-base';
import { ContainerBaseModule } from './container-base';
import { PaymentBaseModule } from './payment-base/payment-base.module';
import { FreeResourceSummaryModule } from './free-resource-summary-base';
import { ResourceConsumptionBaseModule } from './resource-consumption-base';
import { FirstClassRecipeBaseModule } from './first-class-recipe-base/first-class-recipe-base.module';
import { UserTokenBaseModule } from './user-token-base/user-token-base.module';
import { IntegrationTokenBaseModule } from './integration-token-base';
import { IntegrationTokenDelegationBaseModule } from './integration-token-delegation-base';
import { RecipeBaseModule } from './recipe-base';
import { RecipeHandoffBaseModule } from './recipe-handoff-base';
import { ZcpPoolClaimBaseModule } from './zcp-pool-claim-base';
import { Z3HandoverBaseModule } from './z3-handover-base';
import { DeviceLoginBaseModule } from './device-login-base';
import { PromoCodeBaseModule } from './promo-code-base';

@NgModule({
  imports: [
    UserBaseModule,
    ServiceBaseModule,
    ProjectBaseModule,
    PaymentBaseModule,
    SettingsBaseModule,
    ResourceStatisticsBaseModule,
    SubscriptionBaseModule,
    BillingBaseModule,
    ServiceStackBaseModule,
    TransactionDebitBaseModule,
    TransactionCreditBaseModule,
    NotificationBaseModule,
    UserDataBaseModule,
    HttpRoutingBaseModule,
    PortRoutingBaseModule,
    AppVersionBaseModule,
    ProcessBaseModule,
    ClientUserBaseModule,
    ClientBaseModule,
    ClientStatusBaseModule,
    ClientBalanceBaseModule,
    ProjectStatusBaseModule,
    RollbarLibModule,
    ContainerBaseModule,
    ResourceConsumptionBaseModule,
    FreeResourceSummaryModule,
    FirstClassRecipeBaseModule,
    UserTokenBaseModule,
    IntegrationTokenBaseModule,
    IntegrationTokenDelegationBaseModule,
    RecipeBaseModule,
    RecipeHandoffBaseModule,
    ZcpPoolClaimBaseModule,
    Z3HandoverBaseModule,
    DeviceLoginBaseModule,
    PromoCodeBaseModule
  ]
})
export class CoreModule {}
